import { z } from 'zod';

export const GetCollegePredictorResponseSchema = z.object({
  total_no_of_colleges: z.number().int(),
  admission_category_name: z.string(),
  colleges: z.array(
    z.object({
      college_id: z.string(),
      college_name: z.string(),
      college_address: z.string(),
      district_enum: z.string().optional(),
      extra_info: z.string().optional(),
      branches: z.array(
        z.object({
          branch_code: z.string(),
          branch_name: z.string(),
          fee: z.number().int().positive().optional(),
          cutoff: z.number()
        })
      )
    })
  )
});

export type GetCollegePredictorResponseType = z.infer<
  typeof GetCollegePredictorResponseSchema
>;

export const GetCollegePredictorRequestSchema = z.object({
  entrance_exam_name_enum: z.string(),
  admission_category_name_enum: z.string(),
  cutoff_from: z.number(),
  cutoff_to: z.number(),
  reservation_category_code: z.string(),
  branch_codes: z.array(z.string()),
  districts: z.array(z.string()).optional(),
  sort_order: z.enum(['ASC', 'DESC'])
});

export type GetCollegePredictorRequestType = z.infer<
  typeof GetCollegePredictorRequestSchema
>;
